import FulfillmentQueue from './FulfillmentQueue';
export default function FulfillmentVerify() {
  return (
    <FulfillmentQueue
      title="Verify"
      statusFilter="verified"
      emptyMessage="No orders awaiting verification"
    />
  );
}
